// Import Core
import { useState } from 'react';

const useMap = () => {
  const [isMapOpen, setIsMapOpen] = useState(false);
  const toggleMap = () => setIsMapOpen(!isMapOpen);
  
	return { isMapOpen, toggleMap };
};

export default useMap;
